import "./layout-shell.css";
import "./styles.css";
import { initComingSoonNavLinks, initMobileNav } from "./navMobile.js";
import { initThemeLamp } from "./theme.js";
import { initWalletConnect, getWagmiConfig } from "./wallet/reown.js";
import { mountProdEnvBannerIfNeeded, warnStakingEnvIfIncomplete } from "./lib/env.js";
import {
  refreshStakingDashboard,
  bindStakingActions,
  syncStakeButtonsState,
} from "./stakingDashboard.js";
import { initStakingSettings } from "./stakingSettings.js";
import { initXpLeaderboard } from "./stakingLeaderboard.js";
import { initGallerySwitcher } from "./gallerySwitcher.js";
import { getAccount } from "@wagmi/core";

initThemeLamp();
initMobileNav();
initComingSoonNavLinks();
warnStakingEnvIfIncomplete();
mountProdEnvBannerIfNeeded();

window.addEventListener("owlex:account", (e) => {
  void refreshStakingDashboard(e.detail?.address ?? null);
});

window.addEventListener("owlex:staking-refresh", (e) => {
  const addr = e.detail?.address;
  if (addr) {
    void refreshStakingDashboard(addr);
    return;
  }
  const cfg = getWagmiConfig();
  const a = cfg ? getAccount(cfg).address : null;
  void refreshStakingDashboard(a ?? null);
});

window.addEventListener("owlex:staking-selection", () => syncStakeButtonsState());
window.addEventListener("owlex:roost-selection", () => syncStakeButtonsState());
window.addEventListener("owlex:gallery-view", () => syncStakeButtonsState());

initGallerySwitcher();
void initWalletConnect();
bindStakingActions();
initStakingSettings();
initXpLeaderboard();
